<template>
  <v-card id="create">
    <v-speed-dial
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          :color="
            fab
              ? 'red'
              : pallete?.headColor.length > 0
              ? pallete?.headColor
              : 'blue'
          "
          :style="{
            background: fab
              ? 'red'
              : pallete?.headColor.length > 0
              ? pallete?.headColor
              : '',
          }"
          small
          dark
          fab
        >
          <v-icon v-if="fab"> mdi-close </v-icon>
          <v-icon v-else> mdi-plus </v-icon>
        </v-btn>
      </template>
      <v-btn
        @click="showClub = true"
        fab
        dark
        small
        :style="{
          background: pallete?.headColor.length > 0 ? pallete?.headColor : '',
        }"
        :color="pallete?.headColor.length > 0 ? null : 'primary'"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="white" dark v-bind="attrs" v-on="on">
              mdi-card-account-phone-outline
            </v-icon>
          </template>
          <span>باشگاه مشتریان</span>
        </v-tooltip>
      </v-btn>
      <v-btn
        @click="showMap = true"
        fab
        dark
        small
        :style="{
          background: pallete?.headColor.length > 0 ? pallete?.headColor : '',
        }"
        :color="pallete?.headColor.length > 0 ? null : 'primary'"
      >
        <v-icon>mdi-map-marker</v-icon>
      </v-btn>
      <v-btn
        v-if="phon"
        fab
        dark
        small
        :style="{
          background: pallete?.headColor.length > 0 ? pallete?.headColor : '',
        }"
        :color="pallete?.headColor.length > 0 ? null : 'primary'"
        @click="rangMe(phon)"
      >
        <v-icon>mdi-phone</v-icon>
      </v-btn>
      <v-btn
        :style="{
          background: pallete?.headColor.length > 0 ? pallete?.headColor : '',
        }"
        :color="pallete?.headColor.length > 0 ? null : 'primary'"
        dark
        fab
        small
        @click="$emit('getVcf')"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-speed-dial>
  </v-card>
</template>
<script>
export default {
  props: {
    map: Boolean,
    phon: [String, Number],
    pallete: Object,
  },

  computed: {
    showMap: {
      get() {
        return this.map;
      },
      set(val) {
        this.$emit("update:map", val);
      },
    },
  },

  methods: {
    rangMe(url) {
      let a = document.createElement("a");
      a.setAttribute("href", `tel:${url}`);
      a.click();
    },
  },

  data: () => ({
    direction: "top",
    fab: true,
    fling: false,
    hover: false,
    tabs: null,
    top: false,
    right: true,
    bottom: true,
    left: false,
    transition: "slide-y-reverse-transition",
  }),
};
</script>

<style>
/* This is for documentation purposes and will not be needed in your application */
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
</style>
